import { useMemo } from 'react'
import { ESTADO_VITIMA_VAZIO, VITIMAS_POR_ID, situacaoDaVerificacao } from '../../dominio/tabletop/atendimento'
import type { IdAcaoAvaliacao, SessaoAtendimentoTabletop } from '../../dominio/tabletop/atendimento'
import type { ObjetoTabletop } from '../../dominio/tabletop/tipos'
import { FichaClinicaVitima } from '../vitima/FichaClinicaVitima'
import { SeletorFichaVitima } from './atendimento/SeletorFichaVitima'

interface Props {
  objeto: ObjetoTabletop
  aoVincularFicha: (idVitima: string, idFicha: string | null) => void
  /** o estágio e os exames verificados moram na sessão de atendimento da mesa */
  sessao: SessaoAtendimentoTabletop
  aoVerificar: (idVitima: string, idAcao: IdAcaoAvaliacao) => void
  aoMudarEstagio: (idVitima: string, idEstagio: string) => void
}

/**
 * Mesa compartilhada: todos veem e editam, então a ficha aparece completa
 * (modo instrutor) — bloco do ator, XABCDE rápido, secundária e passagem.
 */
export function FichaVitimaMesa({ objeto, aoVincularFicha, sessao, aoVerificar, aoMudarEstagio }: Props) {
  const fichaId = objeto.vitima?.fichaAtendimentoId
  const ficha = fichaId ? VITIMAS_POR_ID[fichaId] : undefined
  const estado = sessao.estadosVitimas[objeto.id]
  const situacao = useMemo(
    () => (ficha ? situacaoDaVerificacao(ficha, estado ?? ESTADO_VITIMA_VAZIO) : null),
    [ficha, estado],
  )
  return <section className="tt-ficha-mesa" aria-label={`Ficha de ${objeto.nome}`}>
    <SeletorFichaVitima idFichaAtual={fichaId ?? null}
      onVincularFicha={id => aoVincularFicha(objeto.id, id)} />
    {!ficha ? <p>Ficha não configurada. Escolha uma ficha clínica acima.</p> :
      <FichaClinicaVitima key={`${objeto.id}:${ficha.id}`} ficha={ficha} modo="instrutor"
        estagioAtual={estado?.estadoEvolucao ?? 'inicial'}
        verificados={situacao!.verificados} desatualizados={situacao!.desatualizados}
        travarVerificados
        aoAlternarVerificado={(idAcao, marcado) => { if (marcado) aoVerificar(objeto.id, idAcao) }}
        aoMudarEstagio={idEstagio => aoMudarEstagio(objeto.id, idEstagio)} />}
  </section>
}
